<template>
  <div :class="getClasses(content)" :style="getStyle(content)"
       v-if=" content.txt !== 'reset' " ><!--
    -->{{ content.txt.trim() }}<!--
    --><span class="chawget-msg-date">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import BaseMessage from '@/components/messages/BaseMessage.vue'

export default {
  name: 'ContentTxt',
  extends: BaseMessage
}

</script>

<style lang="scss" scoped>
div {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
